import { PlusCircleOutlined } from '@ant-design/icons';
import { Card, Col, Grid, Row, Spin, Select, Space, Tag, Button, notification, Modal } from 'antd';
import * as Api from 'api';
import CameraGroupItem from 'components/camera/cameraGroupItem';
import FeederGroupItem from 'components/camera/feederGroupItem';
import LeftCameraMap from 'components/camera/cameraMap';
import { CameraPinType } from 'helpers/types';
import React, { useEffect, useState } from 'react';
import useAuth from 'redux/auth/auth.hook';
import classes from './style.module.scss';

const { useBreakpoint } = Grid;

const SmartFeederGroup = () => {
  const { md } = useBreakpoint();
  const { auth: { profile } } = useAuth();
  const [cameras, setCameras] = useState<CameraPinType[]>([]);
  const [groups, setGroups] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [group, setGroup] = useState('');
  const [command, setCommand] = useState('Open');
  const commands = [
    { id: 1, command: 'force_open', name: 'Open' },
    { id: 2, command: 'force_close', name: 'Close' },
    { id: 3, command: 'all_stop', name: 'All Stop' },
    { id: 4, command: 'alarm_close', name: 'Close With Alarm' },
  ];
  // show group on map
  const [mapGroupName, setMapGroupName] = useState('All');
  const [mapCameras, setMapCameras] = useState<CameraPinType[]>([]);
  const [templates, setTemplates] = useState([]);
  const [template, setTemplate] = useState();
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);

  useEffect(() => {
    if (profile) {
      loadData();
    }
  }, [profile]);

  const loadTemplates = () => {
    Api.SMARTFEEDER_TEMPLATE_GET().then(((res: any) => {
      const data = JSON.parse(res.text);
      setTemplate(data[0].id);
      setTemplates(data);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  useEffect(() => {
    loadTemplates();
  }, []);

  const reloadGroupData = () => {
    setLoading(true);
    Api.SMARTFEEDER_GROUP_GET_ALL().then(((res: any) => {
      const result = JSON.parse(res.text);
      console.log('camera groups', result);
      setGroup(result[0].name);
      setGroups(result);
      setLoading(false);
    })).catch((error: any) => {
      console.log('error ===>', error);
      setLoading(false);
    });
  };

  const loadData = () => {
    Api.SMARTFEEDER_ALL().then(((res: any) => {
      const result = JSON.parse(res.text);
      setCameras(result);
      setMapCameras(result);
      console.log('cameras', result);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
    reloadGroupData();
  };

  const clickAddGroup = () => {
    if (groups.length > 0) {
      const lastGroup = groups[groups.length - 1];
      if (lastGroup.id == 0) {
        return;
      }
    }
    const newGroup = {
      id: 0,
      name: '',
      cameras: [],
    };
    setGroups([...groups, newGroup]);
  };

  const onMapChangeGroup = (gname, gcameras) => {
    setMapGroupName(gname);
    const cameraArr: any[] = [];
    cameras.forEach((item) => {
      if (gcameras.includes(item.id)) {
        cameraArr.push(item);
      }
    });
    setMapCameras(cameraArr);
  };

  const onChangeGroup = (value) => {
    setGroup(value);
  };

  const onChangeCommand = (value) => {
    setCommand(value);
  };

  const onSendCommand = () => {
    const params = {
      group_id: group,
      command,
    };
    console.log('send Command->', params);
    Api.SMARTFEEDER_GROUP_COMMAND(params).then((res: any) => {
      notification.open({
        message: 'The command has been sent.',
      });
    }).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const onApplyTemplate = () => {
    const params = {
      template,
      group_id: group,
    };
    setLoading(true);
    Api.SMARTFEEDER_APPLY_TEMPLATE_GROUP_POST(params).then(((res: any) => {
      setLoading(false);
    })).catch((error: any) => {
      setLoading(false);
      console.log('error ===>', error);
    });
  };

  return (
    <div className={classes.content}>
      <Row>
        <Col md={12} xs={24} className={classes.leftMap}>
          <div className={classes.mapTitle}>
            <h3>Feeder Group : {mapGroupName}</h3>
          </div>
          <LeftCameraMap cameras={mapCameras} />
        </Col>
        <Col md={12} xs={24}>
          <Card title="Feeder Groups" style={{ margin: md ? '12px 12px 0 0' : '2px' }} hoverable>
            <Spin spinning={loading} size="large">
              <div>
                {groups && groups.map((item, index) =>
                  <FeederGroupItem cameras={cameras} groupData={item} onGropUpdate={reloadGroupData} onFocusGroup={(gname, gcameras) => onMapChangeGroup(gname, gcameras)} key={index} />)}
                <div className={classes.addGroup} onClick={clickAddGroup}>
                  <PlusCircleOutlined /> &nbsp;Add a smartfeeder group
                </div>
              </div>
            </Spin>
          </Card>
          <Card title="Group Command" hoverable style={{ margin: md ? '12px 12px 0 0' : '2px' }}>
            <Space style={{ marginBottom: '12px' }}>
              <div className={classes.formInputLabel}>Select the Group:&nbsp;</div>
              <Select
                size="large"
                className={classes.select}
                onChange={onChangeGroup}
                value={group}
              >
                {groups.map((val: any, i) => (
                  <Select.Option key={val.id} value={val.id}>{val.name}</Select.Option>
                ))}
              </Select>
            </Space>
            <Space style={{ marginBottom: '12px', marginLeft: '12px' }}>
              <div className={classes.formInputLabel}>Select the Command:&nbsp;</div>
              <Select
                size="large"
                className={classes.select}
                onChange={onChangeCommand}
                value={command}
              >
                {commands.map((val: any, i) => (
                  <Select.Option key={val.id} value={val.command}>{val.name}</Select.Option>
                ))}
              </Select>
            </Space>
            <div className={classes.formInputLabel} style={{ marginTop: '12px' }}>
              <Button type="primary" onClick={onSendCommand}>Send the Command to the Group</Button>
            </div>
            <div className={classes.formInputLabel} style={{ marginTop: '12px' }}>
              <Button type="primary" onClick={() => { setIsApplyModalOpen(true); }}>Apply the template to the Group</Button>
            </div>
          </Card>
          <Modal title="Apply Template" visible={isApplyModalOpen} onCancel={() => { setIsApplyModalOpen(false); }} onOk={() => { setIsApplyModalOpen(false); onApplyTemplate(); }} okText="Apply">
            <p>Please select the template: </p>
            <Select
              size="large"
              className={classes.select}
              onChange={(value) => setTemplate(value)}
              value={template}
            >
              {templates.map((val: any) => (
                <Select.Option key={val.id} value={val.id}>
                  {val.name}
                </Select.Option>
              ))}
            </Select>
            <p className={classes.formInputLabel}>Select the Group:&nbsp;</p>
            <Select
              size="large"
              className={classes.select}
              onChange={onChangeGroup}
              value={group}
            >
              {groups.map((val: any, i) => (
                <Select.Option key={val.id} value={val.id}>{val.name}</Select.Option>
              ))}
            </Select>
          </Modal>
        </Col>
      </Row>
    </div>
  );
};

export default SmartFeederGroup;
